/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./transformers.vue?vue&type=template&id=2fc14d5a&scoped=true"
import script from "./transformers.vue?vue&type=script&lang=js"
export * from "./transformers.vue?vue&type=script&lang=js"
import style0 from "./transformers.vue?vue&type=style&index=0&id=2fc14d5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc14d5a",
  null
  
)

export default component.exports